import React, { useCallback } from 'react';

function SelectInput(props) {
    const { className, children, onChange, ...otherProps } = props;

    const handleChange = useCallback(
        (e) => {
            if (onChange) onChange(e.target.value);
        },
        [onChange]
    );

    return (
        <select className={className} onChange={handleChange} {...otherProps}>
            {children}
        </select>
    );
}

export default SelectInput;
